// extracted by mini-css-extract-plugin
module.exports = {"agreeSendCardInfo":"agreeSendCardInfo_agreeSendCardInfo__dUCeQ"};